import '../utils/zodConfig';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { routeTree } from '../routeTree.agent.gen';
import { ToastProvider } from '../features/agent/job_change_processes/lib/toast';
import { ApiError, apiErrorRetryDelay, shouldRetryApiError } from '../utils/apiFetch';

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// 401/403 は画面ごとのインラインエラーではなく ErrorPage の案内画面に落とす (Issue #3332)
function shouldThrowToErrorBoundary(error: unknown): boolean {
  return error instanceof ApiError && (error.status === 401 || error.status === 403);
}

// 4xx は再試行しても結果が変わらないため retry しない。429 のみ retry-after 秒待って再試行する (Issue #3329, #3427)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryApiError,
      retryDelay: apiErrorRetryDelay,
      throwOnError: shouldThrowToErrorBoundary,
    },
  },
});

const app = document.getElementById('app');
if (app) {
  const root = ReactDOM.createRoot(app);

  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
      <ToastProvider />
    </StrictMode>
  );
}
